import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { LogOut, Users, User, Trophy } from 'lucide-react';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;
  const linkClass = (path) =>
    `text-sm font-medium transition-colors ${
      isActive(path)
        ? 'text-[color:var(--mft-green)]'
        : 'text-gray-600 hover:text-[color:var(--mft-green)]'
    }`;

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="sticky top-0 z-40 w-full bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between gap-2">
          <Link to={user ? '/discover' : '/'} className="flex items-center gap-2 shrink-0">
            <img src="/logo.jpg" alt="SA Football Connect" className="w-10 h-10 rounded-lg object-cover bg-black" />
            <div className="hidden xs:flex sm:flex flex-col leading-tight">
              <span className="font-bold text-gray-900 text-sm">MzansiFootball</span>
              <span className="text-[10px] uppercase tracking-widest text-[color:var(--mft-green)] font-semibold">Talent Connect</span>
            </div>
          </Link>

          {user ? (
            <nav className="flex items-center gap-2 sm:gap-5">
              <Link to="/discover" className={linkClass('/discover')}>
                <span className="inline-flex items-center gap-1.5">
                  <Users className="w-4 h-4" />
                  <span className="hidden sm:inline">Discover</span>
                </span>
              </Link>
              <Link to="/my-profile" className={linkClass('/my-profile')}>
                <span className={`inline-flex items-center gap-1.5 ${isActive('/my-profile') ? '' : 'sm:text-gray-600'}`}>
                  <User className="w-4 h-4" />
                  <span className="hidden sm:inline">My Profile</span>
                  <span className="sm:hidden text-xs font-semibold">Profile</span>
                </span>
              </Link>
            </nav>
          ) : null}

          <div className="flex items-center gap-2 sm:gap-3 shrink-0">
            {user ? (
              <>
                <span className="hidden md:inline text-xs text-gray-500 max-w-[180px] truncate">{user.email}</span>
                <Button variant="outline" size="sm" onClick={handleLogout} className="gap-1.5 px-2 sm:px-3">
                  <LogOut className="w-4 h-4" />
                  <span className="hidden sm:inline">Logout</span>
                </Button>
              </>
            ) : (
              <>
                <Link to="/login"><Button variant="ghost" size="sm">Log in</Button></Link>
                <Link to="/register"><Button size="sm" className="mft-btn-primary">Sign up</Button></Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
